import { useCallback, useEffect } from "react";
import { useApi, createApiHook } from "../utils/apiUtils";

const useFetchQuestionKinds = () => {
  const { apiGet } = useApi();
  const useApiState = createApiHook([]);
  const { data, error, loading, startLoading, setResponse } = useApiState();

  const fetchKinds = useCallback(async () => {
    startLoading();
    const response = await apiGet("/questions/kinds", "Error al obtener los tipos de pregunta");
    setResponse(response);
    return response?.data;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    fetchKinds();
  }, [fetchKinds]);

  return { data, error, loading, refetch: fetchKinds };
};

export default useFetchQuestionKinds;
